import React from "react";
import { Route } from "react-router-dom";
import { SEPARATED_ID } from "../variables/constants";
import dayjs from "dayjs";
import { API_NAME } from "../constants";


export  const getActiveNavbar = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].secondary;
      }
    }
    return false;
  };
export const filterRoutes = (routes, userLevel, moduleRights, layout=["/console"]) => {
  return routes
    .filter(route =>
      layout.includes(route.layout) &&
      route.level >= userLevel && 
	  (route.moduleId === 0 || moduleRights?.some(module => module.mri_module_id === route.moduleId))
    )
    .map(route => ({
      ...route,
      children: Array.isArray(route.children)
        ? filterRoutes(route.children, userLevel, moduleRights, layout)
        : undefined
    }));
};

export const getRoutes = (routes, layout=["/console"]) => {
  return routes
	.map((prop, index) => {
	  if (layout.includes(prop.layout)) {
		return (			
		  <React.Fragment key={`${prop.path}-${index}`}>
			<Route path={prop.path.startsWith('/') ? prop.path : `/${prop.path}`} element={prop.component} />
			{Array.isArray(prop.children) && getRoutes(prop.children)}
		  </React.Fragment>
		);
	  } else {
		return null;
	  }
	});
};

export const getActiveRoute = (routes, pathname) => {
    routes.forEach((route) => {
      if (`${route.layout}/${route.path}` === pathname) {
        document.title = `${API_NAME} - ${route.name}`;
      } else if (route.children) {
        route.children.forEach((child) => {
          if (`${route.layout}/${child.path}` === pathname) {
            document.title = `${API_NAME} - ${child.name}`;
          }
        });
      }
    });
};

export const NumberFormatter = (number, decimal=2, undifinedVal='') => {	
	return number !== undefined 
    ? parseFloat(number).toFixed(decimal).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : undifinedVal;
};

export const FullDateFormat = (dateStr) => {
	const formattedDate = new Date(dateStr).toLocaleDateString("en-US", {
		year: "numeric",
		month: "long",
		day: "2-digit"
	  });

	return formattedDate;
}

export const formatDateTimeOrNull = (val, format) => {
	if (!val || val === undefined) return null;
	return dayjs.isDayjs(val) ? val.format(format) : dayjs(val).format(format);
};

export const handleTableChange = (doSearch, filters) => (pagination, tableFilters, sorter) => {
  const columnFilters = Object.fromEntries(
    Object.entries(tableFilters).map(([key, value]) => [
      key.substring(4), 
      value ? value.join(', ') : '',
    ])
  );

  const sorting = sorter.field ? {
    sortby: sorter.field.substring(4), 
    sortorder: sorter.order === 'descend' ? 'desc' : 'asc',
  } : {};

  doSearch({
    ...filters,
    paginate: pagination.pageSize,
    page: pagination.current,
    ...sorting,
    ...columnFilters,
  });
};

export const generateCRUDRoutes = ({
	mainTitle, 
	basePath, 
	mainComponent, 
	layout, 
	icon, 
	subTitle, 
	viewComponent, 
	createComponent, 
	editComponent,
	isMainMenu=true, 
	submodules=[],
	viewSubmodules=[],
	detailTitle="Details",
	paramName = null,
	level=1,
	moduleId=0,
	}) => {
		
	const pathSegments = basePath.split('-');
	const recordId =  paramName || `${pathSegments[pathSegments.length - 1].slice(0, -1)}Id`;
	return {
		name: `${mainTitle}`,
		path: `${basePath}`,
		component: mainComponent,
	    layout,	    
	    icon,	    
	    isMainMenu,
		level,
		moduleId,
	    children: [
		  {
		    name: `${subTitle} ${detailTitle}`,
		    layout: "/console",
		    path: `${basePath}/:${recordId}/view`,
		    component: viewComponent,
		    isMainMenu: false,
			level,
			moduleId,
		    children: [
				...viewSubmodules,
			],
		  },
		  {
		    name: `Create ${subTitle}`,
		    layout: "/console",
		    path: `${basePath}/add`,
		    component: createComponent,
		    isMainMenu: false,
			level,
			moduleId,
		  },
		  {
		    name: `Edit ${subTitle}`,
		    layout: "/console",
		    path: `${basePath}/:${recordId}/edit`,
		    component: editComponent,
		    isMainMenu: false,
			level,
			moduleId,
		  },
		  ...submodules,
		]
	}
};

export const employeeName = (userDetail) => {   
	if (!userDetail) return '';
	const {ude_first_name, ude_middle_name, ude_last_name} = userDetail;

	return [ude_first_name, ude_middle_name, ude_last_name]
		.filter(Boolean)
		.join(' ');
};


export const contactDetailName = (contactDetail) => {   
	if (!contactDetail) return '';
	const {cde_first_name, cde_middle_name, cde_last_name} = contactDetail;

	return [cde_first_name, cde_middle_name, cde_last_name]
		.filter(Boolean)
		.join(' ');
};

export const isSeparatedEmployee = (input) => {
	const statusId = typeof input === 'object' ? input?.emp_employment_status_id : input;
	return statusId === SEPARATED_ID;
}


export const formatAddress = (address) => {
	if (!address) return '';
	const {add_address_line1, add_address_line2, add_city, add_postal_code} = address;

	return [add_address_line1, add_address_line2, add_city, add_postal_code]
		.filter(Boolean)
		.join(', ');
};

export const getLabel = (list, value, fallback = '-', returnObject = false) => {
  const item = list?.find(item => String(item.value) === String(value));
  return returnObject ? item ?? null : item?.label ?? fallback;
};

export const getValueByText = (dataList, text) => {
  const type = dataList.find(item => item.text === text);
  return type ? type.value : null;
}

export const getAccessRightLevelName = (value) => {
	return `${value === 2 ? 'All' : value === 1 ? 'Own Records': 'No'}`;
}

export const getYesNoValue = (value) => {
	return `${value === 1 ? 'Yes': 'No'}`;
}

export const getAccessGroupLevelName = (value) => {
	let groupName = '';

	switch(value){
		case 1:
			groupName = 'Super Admin Level';
		break;
		case 2:
			groupName = 'Admin Level';
		break;
		case 3:
			groupName = 'User Level';
		break;
		case 4:
			groupName = 'Client Level';
		break;
		default:
			break;
	}

	return groupName;
}


export const formatDateRange = (from, to = null, showYear = true, year = true, showTime = false) => {
	if (!from) return "";

	const start = new Date(from.replace(" ", "T"));
	let startFormatted = start.toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
		year: showYear ? "numeric" : undefined, 
	});

	if (showTime) {
		const startTime = start.toLocaleTimeString("en-US", {
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
		});
		startFormatted += ` - ${startTime}`;
	}

	if (!to) return startFormatted;

	const end = new Date(to.replace(" ", "T"));
	let endFormatted = end.toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
		year: year ? "numeric" : undefined,
	});

	if (showTime) {
		const endTime = end.toLocaleTimeString("en-US", {
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
		});
		endFormatted += ` - ${endTime}`;
	}

	return `${startFormatted} - ${endFormatted}`;
};


export const getNameInitials = (name) => {
	return name?.split(" ").map((n) => n[0]).join("").toUpperCase() || "?";
}